import { ClientStatus, Maybe } from "@/gql/graphql";

import pinnedClients from "../store/PinnedClients";

type Item = {
  id: string;
  profile?: Maybe<{
    fullName: string;
  }>;
  status: ClientStatus;
};

export function sortByClientNameAsc(itemOne: Item, itemTwo: Item): number {
  const nameOne = itemOne.profile?.fullName.toLowerCase() ?? "";
  const nameTwo = itemTwo.profile?.fullName.toLowerCase() ?? "";
  if (nameOne < nameTwo) return -1;
  if (nameOne > nameTwo) return 1;
  return 0;
}

export function sortByClientNameDesc(itemOne: Item, itemTwo: Item): number {
  const nameOne = itemOne?.profile?.fullName.toLowerCase() ?? "";
  const nameTwo = itemTwo?.profile?.fullName.toLowerCase() ?? "";
  if (nameOne < nameTwo) return 1;
  if (nameOne > nameTwo) return -1;
  return 0;
}

export function sortByStatus(itemOne: Item, itemTwo: Item): number {
  const nameOne = itemOne.status.toLowerCase();
  const nameTwo = itemTwo.status.toLowerCase();
  if (nameOne < nameTwo) return -1;
  if (nameOne > nameTwo) return 1;
  return 0;
}

export function sortByPinned(itemOne: Item, itemTwo: Item): number {
  const itemOnePinned = pinnedClients.has(itemOne.id);
  const itemTwoPinned = pinnedClients.has(itemTwo.id);

  if (itemOnePinned && !itemTwoPinned) return -1;
  if (!itemOnePinned && itemTwoPinned) return 1;
  if (itemOnePinned && itemTwoPinned) {
    return sortByClientNameAsc(itemOne, itemTwo);
  }
  return 0;
}

export function sortByPinnedPrimarily(
  secondarySorting: (itemOne: Item, itemTwo: Item) => number
): (itemOne: Item, itemTwo: Item) => number {
  return (itemOne: Item, itemTwo: Item) => {
    const order = sortByPinned(itemOne, itemTwo);
    return order === 0 ? secondarySorting(itemOne, itemTwo) : order;
  };
}
